"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var components_1 = require("../../../../common/components");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        root: (_a = {
                flex: '1 1 30%',
                background: theme.youwell.colors.defaultBackground,
                borderRadius: theme.youwell.shapes.borderRadius,
                boxShadow: theme.shadows[3],
                padding: theme.spacing(2, 4),
                display: 'flex',
                flexDirection: 'column',
                '&:nth-child(2)': {
                    margin: theme.spacing(0, 2),
                }
            },
            _a[theme.breakpoints.down('xs')] = {
                flexBasis: '80%',
                margin: theme.spacing(2),
            },
            _a),
        icon: {
            margin: theme.spacing(1, 0),
        },
        heading: {},
        subHeading: {},
        content: {
            flex: '1 1 auto',
            marginTop: theme.spacing(2),
        },
        actionButton: {
            marginTop: theme.spacing(2),
        },
    });
}, { name: 'InfoBox' });
var InfoBox = function (_a) {
    var heading = _a.heading, subHeading = _a.subHeading, Icon = _a.Icon, children = _a.children, ActionPopup = _a.ActionPopup, ActionPopupProps = _a.ActionPopupProps, actionText = _a.actionText, actionPopupHeading = _a.actionPopupHeading, backgroundColor = _a.backgroundColor;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.root, style: { background: backgroundColor } },
        Icon && React.createElement(Icon, { className: classes.icon }),
        React.createElement(core_1.Typography, { variant: "h6", className: classes.heading }, heading),
        subHeading && (React.createElement(core_1.Typography, { className: classes.subHeading }, subHeading)),
        React.createElement("div", { className: classes.content }, children),
        ActionPopup && (React.createElement(components_1.ModalAction, { modalHeading: actionPopupHeading || '', buttonProps: { className: classes.actionButton, variant: 'contained', color: 'secondary' }, buttonText: actionText, Modal: ActionPopup, ModalProps: ActionPopupProps }))));
};
InfoBox.defaultProps = {
    Icon: null,
    subHeading: null,
    ActionPopup: null,
    ActionPopupProps: null,
    actionText: null,
    actionPopupHeading: null,
    backgroundColor: null,
};
exports.default = InfoBox;
